export default async function convertImageToByteArray(file) {
  const byteArraysAsync = Object.keys(file).map(async (key) => {
    const image = file[key];
    const buffer = await image.arrayBuffer();
    const byteArray = new Int8Array(buffer);

    const fileName =
      image?.name?.substring(0, image?.name?.lastIndexOf(".")) || image?.name;

    const fileExt =
      image?.name?.substring(
        image?.name?.lastIndexOf("."),
        image?.name?.length
      ) || image?.name;

    return { fileName, fileExt, byteArray };
  });

  const byteArrays = await Promise.all(byteArraysAsync);
  console.log("byteArrays", byteArrays);
  return byteArrays;
}

export const fileToByteArray = (file) => {
  const files = Object.keys(file).map(async key => {
    return new Promise((resolve, reject) => {
      try {
        let reader = new FileReader();
        let byteArray = [];
        reader.readAsArrayBuffer(file[key]);
        reader.onloadend = (evt) => {
          if (evt.target.readyState === FileReader.DONE) {
            let arrayBuffer = evt.target.result;
            const array = new Uint8Array(arrayBuffer);
            array.forEach((byte) => {
              byteArray.push(byte);
            });
          }
          const fileName =
            file[key]?.name?.substring(0, file[key]?.name?.lastIndexOf(".")) || file[key]?.name;

          const fileExt =
            file[key]?.name?.substring(
              file[key]?.name?.lastIndexOf("."),
              file[key]?.name?.length
            ) || file[key]?.name;

          resolve({ fileName, fileExt, byteArray });
        };

      } catch (e) { reject(e); }
    });
  });
  const result = Promise.all(files);
  console.log('result', result);
  return result;
};
